<script setup lang="ts">
defineSlots<{ default: () => unknown }>();
</script>
<template>
  <section class="flex w-full justify-center px-4 py-12 md:py-24">
    <slot name="default"></slot>
  </section>
</template>
